var map = {
	"./ui-navigation-esm": 90674,
	"./ui-navigation-esm.js": 90674,
	"./ui-navigation-esm.production": 99085,
	"./ui-navigation-esm.production.js": 99085,
	"./ui-navigation-esm.release": 43129,
	"./ui-navigation-esm.release.js": 43129
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 40127;